import { useMediaQuery } from '@mantine/hooks'

export function useHoverMediaQuery(opts?: { not?: boolean }) {
  const queryString = opts?.not
    ? 'not all and (hover: none)'
    : '(hover: hover) and (pointer: fine)'
  return useMediaQuery(queryString)
}
